import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Parametro } from "app/types/Parametro"
import { resetAll } from "./actions/resetAll"

const initialState: Record<string, string> = {}

export const parametrosSlice = createSlice({
    name: "parametros",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        inserirOuAtualizar: (state, action: PayloadAction<Parametro>) => {
            const { Nome, Valor } = action.payload
            // Atualização direta sem cópia desnecessária
            if (state[Nome] !== Valor) {
                state[Nome] = Valor
            }
        },
        remover: (state, action: PayloadAction<string>) => {
            const nome = action.payload
            // Delete mais eficiente
            if (nome in state) {
                delete state[nome]
            }
        },
    }
})

export default parametrosSlice.reducer

export const { inserirOuAtualizar, remover } = parametrosSlice.actions